import { useMemo } from 'react';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import AudienceAccessCell from '../components/cells/AudienceAccessCell';
import PublishStatusCell from '../components/cells/PublishStatusCell';
import DateCell from '../components/cells/DateCell';
import NameCell from '../components/cells/ContentNameCell';
import { TitleCell, LanguageCell, CampaignCell, ContentGroupNameCell } from '../components/cells/TextCells';
import UserCell from '../components/cells/UserCell';
import ApprovalStatusCell from '../components/cells/ApprovalStatusCell';
import TeamCell from '../components/cells/TeamCell';
import PublishDateCell from '../components/cells/PublishDateCell';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TABLE_COLUMN_CONFIG = {
  minWidth: 50,
  sortable: true,
  width: 150
};
const DATE_CELL_TABLE_COLUMN_CONFIG = {
  width: 175,
  renderCell: props => /*#__PURE__*/_jsx(DateCell, Object.assign({}, props))
};
const USER_CELL_TABLE_COLUMN_CONFIG = {
  sortable: false,
  renderCell: props => /*#__PURE__*/_jsx(UserCell, Object.assign({}, props))
};
function createTableColumnConfig({
  standardConfig = {},
  overrideConfig = {}
}) {
  return Object.assign({}, DEFAULT_TABLE_COLUMN_CONFIG, standardConfig, overrideConfig);
}
const useRenderCustomColumn = ({
  reviewData,
  propertyTableColumnConfigs = {}
}) => {
  const contentPlatformPropertyTableColumnStandardConfigs = useMemo(() => ({
    [CONTENT_PLATFORM_PROPERTY_NAME.NAME]: {
      width: 500,
      renderCell: props => /*#__PURE__*/_jsx(NameCell, Object.assign({}, props)),
      hoverCell: true
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT]: DATE_CELL_TABLE_COLUMN_CONFIG,
    [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_AT]: DATE_CELL_TABLE_COLUMN_CONFIG,
    [CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE]: {
      width: 175,
      renderCell: props => /*#__PURE__*/_jsx(PublishDateCell, Object.assign({}, props))
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: USER_CELL_TABLE_COLUMN_CONFIG,
    [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_BY_USER_ID]: USER_CELL_TABLE_COLUMN_CONFIG,
    [CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE]: {
      sortable: false,
      renderCell: props => /*#__PURE__*/_jsx(LanguageCell, Object.assign({}, props)),
      width: 200
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.TITLE]: {
      renderCell: props => /*#__PURE__*/_jsx(TitleCell, Object.assign({}, props)),
      width: 300
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.CAMPAIGN]: {
      sortable: false,
      renderCell: props => /*#__PURE__*/_jsx(CampaignCell, Object.assign({}, props))
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
      renderCell: props => /*#__PURE__*/_jsx(PublishStatusCell, Object.assign({
        reviewData: reviewData
      }, props))
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS]: {
      renderCell: props => /*#__PURE__*/_jsx(AudienceAccessCell, Object.assign({}, props)),
      width: 200
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID]: {
      renderCell: props => /*#__PURE__*/_jsx(ContentGroupNameCell, Object.assign({}, props)),
      width: 200,
      sortable: false
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.APPROVAL_PUBLISH_STATUS]: {
      renderCell: props => /*#__PURE__*/_jsx(ApprovalStatusCell, Object.assign({}, props)),
      sortable: false,
      width: 200
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.TEAM_PERMS]: {
      renderCell: props => /*#__PURE__*/_jsx(TeamCell, Object.assign({}, props)),
      sortable: false,
      width: 200
    }
  }), [reviewData]);
  return ({
    columnId
  }) => {
    const tableColumnStandardConfig = contentPlatformPropertyTableColumnStandardConfigs[columnId];
    const overrideTableColumnConfig = propertyTableColumnConfigs[columnId];
    if (tableColumnStandardConfig === undefined && overrideTableColumnConfig === undefined) {
      return null;
    }
    return createTableColumnConfig({
      standardConfig: tableColumnStandardConfig,
      overrideConfig: overrideTableColumnConfig
    });
  };
};
export default useRenderCustomColumn;